export default function () {
  $('.ui.sticky').sticky({ context: '#sticky-map', offset: 100, silent: true });
}
